import React, { useEffect } from "react";
import { Form, Button } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import FormItem from "./FormItem";
import { requiredField } from "utils/crudSagaHelper";
import InputWrapper from "./InputWrapper";

function DynamicList({
    name,
    label,
    placeholder = "Enter item",
    minItems = 1,
    maxItems,
    addButtonClass,
    mode = "edit",
    recordData,
}) {
    const form = Form.useFormInstance();

    useEffect(() => {
        if (form && mode !== "view") {
            const currentValues = form.getFieldValue(name);
            if (!currentValues || currentValues.length === 0) {
                form.setFieldValue(name, [""]);
            }
        }
    }, [form, name, mode]);

    if (mode === "view") {
        const values =
            recordData?.[name] && Array.isArray(recordData[name])
                ? recordData[name].filter(item => item && item.trim() !== "")
                : [];

        if (values.length === 0) return null;

        return (
            <FormItem label={label}>
                <ul className="list-disc ml-5 text-base label-value dark:text-white">
                    {values.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
            </FormItem>
        );
    }

    return (
        <Form.List
            name={name}
            initialValue={[""]}
            rules={[
                requiredField(),
                {
                    validator: async (_, value) => {
                        if (!value || value.length < minItems) {
                            return Promise.reject(
                                new Error(
                                    `At least ${minItems} item${
                                        minItems > 1 ? "s" : ""
                                    } required`
                                )
                            );
                        }
                        return Promise.resolve();
                    },
                },
            ]}
        >
            {(fields, { add, remove }) => (
                <>
                    {fields.map(({ key, name: fieldName, ...restField }, index) => (
                        <FormItem key={key} label={index === 0 ? label : ""}>
                            <div className="flex items-center gap-2">
                                <FormItem {...restField} name={fieldName} noStyle>
                                    <InputWrapper
                                        placeholder={placeholder}
                                    />
                                </FormItem>

                                {fields.length > minItems && (
                                    <MinusCircleOutlined
                                        className="text-gray-500 dark:text-white cursor-pointer"
                                        onClick={() => remove(fieldName)}
                                    />
                                )}
                            </div>
                        </FormItem>
                    ))}

                    {(!maxItems || fields.length < maxItems) && (
                        <FormItem>
                            <Button
                                type="dashed"
                                onClick={() => add()}
                                icon={<PlusOutlined />}
                                className={addButtonClass}
                            >
                                Add another
                            </Button>
                        </FormItem>
                    )}
                </>
            )}
        </Form.List>
    );
}

export default DynamicList;
